/**
 * Created by zhengyi.fu on 2020/6/8.
 */
let date = function(timestamp,sep='-'){
    let _date = new Date(timestamp);
    let y = _date.getFullYear();
    let m = _date.getMonth()+1;
    let d = _date.getDate();
    return "" + y + sep + doubleNum(m) + sep +  doubleNum(d);
}

let doubleNum = function (n) {
    if(n.length>2 || n>100){
        return n;
    }
    n = parseInt(n);
    return n>=10 ? "" + n : "0" + n;
}

let time = function (timestamp, sep=":") {
    let _date = new Date(timestamp);
    let h = _date.getHours();
    let m = _date.getMinutes();
    let s = _date.getSeconds();
    return doubleNum(h) + sep + doubleNum(m) + sep +  doubleNum(s);
}

let dateTime = function (timestamp, dateSep="-", timeSep=":") {
    return date(timestamp, dateSep) + " " + time(timestamp, timeSep);
}

/**
 * 返回1970年至今的毫秒数
 * @param secs
 * @returns {Date}
 */
let dateWithTimeIntervalSince1970 = function(secs) {
    let timestamp = secs;
    let newDate = new Date();
    newDate.setTime(timestamp);
    return newDate;
}

let toYuan = function(money) {  //分->显示元
    if(money === "") return "";
    let a = parseInt(money)/100;
    let str = a + '';
    let arr = str.split('.');
    arr[1] = ((arr[1] || '') + '00');
    for(let i = 0; i<arr.length; i++){
        arr[i] = arr[i].replace(/[^0-9\-]/);
    }
    arr[1] = arr[1].substr(0, 2);
    return [arr[0], arr[1]].join('.');
}

let keepTwodecimalFull = function (num) {//保留两位小数
    let result = parseFloat(num);
    if(isNaN(result)){
        return "";
    }
    result = Math.round(num * 100) / 100;
    var s_x = result.toString();
    var pos_decimal = s_x.indexOf('.');//小数点的所索引值
    
    //当整数时，pos_decimal = -1 自动补0
    if(pos_decimal < 0){
        pos_decimal = s_x.length;
        s_x += '.';
    }
    while (s_x.length <= pos_decimal + 2){
        s_x += '0';
    }
    return s_x;
}

module.exports = {
    date,
    time,
    dateTime,
    doubleNum,
    dateWithTimeIntervalSince1970,
    keepTwodecimalFull,
    toYuan
}



// WEBPACK FOOTER //
// ./src/filters/filters.js